/* eslint-disable @typescript-eslint/no-explicit-any */
import { switchMap, first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { fromUserActions, userQuery, UserState } from '../../+state';

/**
 * Gets User for account-details screen
 */
@Injectable()
export class UserResolver {
  constructor(private _store: Store<UserState>) {}

  /*
   * Resolve User
   * 1. Selects getUser from the store
   * 3. Check if credit user is present
   * - If state is empty:
   *   1. Call getUser
   * 4. Return user from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(userQuery.getUser).pipe(
      switchMap(user => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getUser();
        return of(user);

        // if (!user) {
        //   this.getUser();
        // }
        // return of(user);
      }),
      first()
    );
  }

  /*
   * trigger fetching credit user
   * 1. Dispatch getUser action
   * 2. Listening to setCreditUser
   */
  private getUser() {
    this._store.dispatch(fromUserActions.getUser());
  }
}
